import { isWeChat, isAndroid } from './getDevice'
// import { Toast } from 'antd-mobile'
import GuideBrowserManager from '@/common/guideBrowser'

const appInstall = function (router = '/sell/index', queryOpt: any = {}) {
  if (isWeChat()) {
    const inst = new GuideBrowserManager()
    inst.show()
    // Toast.info('请在浏览器中打开')
    return
  }
  let queryStr = encodeURIComponent(
    Object.keys(queryOpt)
      .map((key) => `${key}=${queryOpt[key]}`)
      .join('&')
  )
  queryStr = queryStr ? `?${queryStr}` : ''
  const link = `https://hk.poizon.com/router${router}${queryStr}`

  const diffStr = isAndroid()
    ? '&apn=com.shizhuang.poizon.hk'
    : '&ibi=com.shizhuang.poizon.hk&isi=1509915974&efr=1'
  window.location.href = `https://poizon2hk.page.link/?link=${link}${diffStr}`
}

export default appInstall
